import {
    queryOptions,
    useQuery,
  } from '@tanstack/react-query';
  
  import { baseAPI } from '~shared/api/base-api';
  import { QUERY_KEYS } from '~shared/api/query-keys';
  
import type { AuditFilterOption } from './get-audit-resources';

  export const getAuditEventsAPI = async () => {
    const response = await baseAPI.get<Array<AuditFilterOption>>(
      `audit-logs/events`,
    );
    return response.data;
  };
  
  export const getAuditEventsOptions = () => {
    return queryOptions({
      queryKey: QUERY_KEYS.AUDIT_EVENTS(),
      queryFn: () => getAuditEventsAPI(),
    });
  };
  
  export const useGetAuditEvents = () => {
    return useQuery(getAuditEventsOptions());
  };
  